import axios from "axios";

interface IGetTotalRentalDaysParams {
    pickupDate: string,
    dropoffDate: string
}

export const getTotalRentalDays = async (params: IGetTotalRentalDaysParams): Promise<number> => {
    const response = await axios.get('/booking/instool/total-rental-days',{
        params
    });
    return response.data;
};


export default getTotalRentalDays;

